/**
 *  © 2015 -2022 HCL Technologies Limited, all rights reserved.
 *  Material published by HCL Technologies on these web pages/mobile
 *  app may not be reproduced without permission.
 */

/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import OldMyLists from './OldMyLists';
import NewMyLists from './NewMyLists';
const MyList = (props) => {
  const isNewMyListing = props?.fields?.MyListType?.value?.toLowerCase() === 'list2';

  return (
    <React.Fragment>
      {isNewMyListing ? <NewMyLists {...props}></NewMyLists> : <OldMyLists {...props}></OldMyLists>}
    </React.Fragment>
  );
};

export default MyList;
